import script from "./GoskluchSignDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoskluchSignDialog.vue?vue&type=script&setup=true&lang=ts"

import "./GoskluchSignDialog.vue?vue&type=style&index=0&id=6939d8d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6939d8d0"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QIcon});
